import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { getOptionAvailability } from "../../common-filters-components/option-availability";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import CheckboxOption from "../../common-filters-components/CheckboxOption";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useState } from "react";
import { Row } from "@/app/components/lib/my-bootstrap";
interface Props {
  filter: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  isFromFilters?: boolean;
  outOfStockKeys?: string[];
  disabledKeys?: string[];
  allow_user_request_stock_availability_reminder?: boolean;
}

const SelectOption: React.FC<Props> = ({
  filter,
  state,
  setState,
  unAvailabeKeys = [],
  isFromFilters,
  outOfStockKeys,
  disabledKeys,
  allow_user_request_stock_availability_reminder,
}) => {
  const options = filter.data;
  const t = useTranslation();
  const [showMore, setShowMore] = useState(!isFromFilters);
  const initialMaxItems = 4;

  const multiSelect = filter.configurations.is_multi_select;
  const handleOption = (key: string) => {
    const currentSelected = toggleOption(state, key, multiSelect);
    setState(currentSelected);
  };

  return (
    <>
      <ul
        style={{
          display: "grid",
          gap: 8,
          margin: 0,
          padding: 0,
          listStyleType: "none",
        }}
      >
        {options
          ?.filter(
            (op, idx) =>
              !isSelected(unAvailabeKeys, op.key) &&
              (showMore || idx < initialMaxItems),
          )
          ?.map((option) => {
            const { disabled, outOfStock, allowSelectOutOfStock, isDisabled } =
              getOptionAvailability({
                optionKey: option.key,
                unAvailabeKeys,
                outOfStockKeys,
                disabledKeys,
                allowRequestStockReminder:
                  allow_user_request_stock_availability_reminder,
              });
            return (
              <CheckboxOption
                key={option.key}
                label={option.value}
                disabled={disabled}
                checked={isSelected(state, option.key)}
                toggleOption={() => handleOption(option.key)}
                is_multi_select={multiSelect}
                outOfStock={outOfStock}
                allowSelectOutOfStock={allowSelectOutOfStock}
                isDisabled={isDisabled}
              />
            );
          })}
      </ul>
      {options?.length! > initialMaxItems && !showMore && (
        <Row>
          <span className="filter-show-more" onClick={() => setShowMore(true)}>
            {t.show_more}
          </span>
        </Row>
      )}
    </>
  );
};
export default SelectOption;
